module.exports = __webpack_public_path__ + "static/img/empty-paper-icon.7269db37.png";